import {defineStore} from 'pinia';
import {ModuleContext} from './moduleConst';
import accountApi from '@/apis/auth/accountApi';
import moment from 'moment';

const state = {
  context: {token: '', sessionId: '', BambooSessionId: ''},
  postedDate: moment(new Date()),

  /**
   * Trạng thái Collapse của left menu
   * HQMINH 09.06.2023
   */
  leftMenuState: false,

  /**
   * @description Tham số báo cáo (Lấy từ Tham số báo cáo)
   * @author nvthinh 25.07.2023
   */
  reportParam: {},
};
const actions = {
  // Cập nhật token của context (nvthinh 17.04.2024)
  async updateToken(token, expiredToken, refreshToken) {
    if (token) {
      this.context.Token = token;
    }

    if (typeof expiredToken === 'string') {
      this.context.ExpiredToken = expiredToken;
    }

    if (refreshToken) {
      this.context.RefreshToken = refreshToken;
    }

    // Cập nhật lại thời gian đăng nhập khi refresh token (nvthinh 5.6.2024)
    if (this.context.Context && typeof this.context.Context === 'object') {
      this.context.Context.LoginDate = new Date();
    }
  },

  async getToken(payload) {
    const context = await accountApi.getToken(payload);
    Object.assign(this.context, context);
    return context;
  },

  /**
   * check tồn tại db trước, nếu tồn tại thì mới get token
   * @param {*} payload
   * nvxuan 23.11.2023
   * @returns object = {ExistsDb, Token}
   */
  async getTokenV2(payload) {
    const res = await accountApi.getTokenV2(payload);

    if (res.ExistsDb) {
      Object.assign(this.context, res.Token);
    }

    return res;
  },

  /**
   * Từ misaid sẽ gọi về callback api, trên api sẽ xử lý để chọn dữ liệu làm việc
   * Dựa theo phiên bản dữ liệu đó sẽ điều hướng về cụm api tương ứng và mã hóa thông tin user, database để truyền kèm
   * Client nhận dc token này sẽ gọi lên account api để đăng nhập
   */
  async loginCallback(payload) {
    const context = await accountApi.loginCallback(payload);

    this.context = context;

    return context;
  },

  /**
   * Thực hiện 1 số hành động khác sau login
   */
  async executeAfterLogin() {
    try {
      let termsPrivacy = await accountApi.executeAfterLogin();
      if (termsPrivacy && window._misaAgreementLib.IsActiveMisaAgreement) {
        this.context.Context.TermsPrivacy = termsPrivacy;
      }
    } catch (ex) {
      console.log(ex);
    }
  },

  /**
   * xác nhận thỏa thuận mua hàng
   * vqphong - 04/06/2024
   */
  async acceptAgreementTermsPrivacy(proxy) {
    try {
      // xác nhận thỏa thuận với misa ID
      let accept = await accountApi.acceptAgreementTermsPrivacy();

      // xác nhận chưa thành công => trả về thông tin thỏa thuận, gán lại context và cho reload trang
      if (accept) {
        this.context.Context.TermsPrivacy = accept;
        location.reload();
      } else {
        // thành công ~ các thông tin thỏa thuận/ chính sách đều null
        delete this.context.Context.TermsPrivacy;
        proxy.$router.push('/');
      }
    } catch (err) {
      proxy.loading = false;
      console.log(err);
    }
  },

  /**
   * Get link từ MisaID
   */
  async getMisaIdLink(payload) {
    try {
      return await accountApi.getMisaIdLink(payload);
    } catch (ex) {
      return null;
    }
  },

  /**
   * Lấy lịch sử thỏa thuận hoặc chính sách
   * @param {*} payload
   * pvdat1 28/02/2024
   */
  async getHistoryAgreement(payload) {
    try {
      return await accountApi.getHistoryAgreement(payload);
    } catch (error) {
      return null;
    }
  },

  /**
   * Cập nhật postedDate
   * @param {*} state
   * @param {*} payload
   * tvtoan 17/05/2023
   */
  updatePostedDate(payload) {
    if (payload && payload.PostedDate) {
      this.context.PostedDate = payload.PostedDate;
      this.$state.postedDate = payload.PostedDate;
    }
  },

  /**
   * Đăng xuất
   */
  async logout() {
    try {
      // Dùng trực tiếp hàm logout của API (nvthinh 5.6.2024)
      await accountApi.logout();
    } catch (ex) {
      // khi bị exception System.InvalidOperationException: StatusCode cannot be set because the response has already started.
      // thì cứ redirect đến login
    }

    // Loại bỏ token, cache
    this.context = null;
    localStorage.removeItem('context');
    const url = window._misaId.getUrl('logoutUrl');
    location.href = url;
  },

  /**
   * Xử lý đăng nhập thông tin tài khoản và set token
   */
  async login() {
    const context = await accountApi.login();
    this.context = context;

    return context;
  },

  /**
   * cập nhật client_id vào context
   * @param {*} state
   * @param {*} clientid
   */
  updateSocketClientId(clientid) {
    this.context.BambooSessionId = clientid;
  },

  /**
   * Cập nhật lại trạng thái Collapse menu
   * HQMINH 09.06.2023
   */
  updateLeftMenu(payload) {
    this.leftMenuState = payload;
  },

  /**
   * @description Cập nhật lại tham số lập báo cáo
   * @author nvthinh 25.07.2023
   */
  updateReportParam(param) {
    this.reportParam = Object.assign(param);
  },

  /**
   * @description Sự kiện đóng cảnh báo hết hạn license
   * @param {*} payload
   * nvxuan 21.09.2023
   */
  async closeWarningDate(payload) {
    // Lưu xuống DB
    await accountApi.closeWarningDate(payload);

    // Update lại context
    // popupType 1 Top | 2 Center | 3 Bottom-Right
    if (payload?.WarningPopupType == 1 && this.context?.Context?.WarningExpied?.ShowWarningExpiredDateTop == true) {
      this.context.Context.WarningExpied.ShowWarningExpiredDateTop = false;
    } else if (payload?.WarningPopupType == 3 && this.context?.Context?.WarningExpied?.ShowWarningExpiredDate == true) {
      this.context.Context.WarningExpied.ShowWarningExpiredDate = false;
    }
  },

  /**
   * Kiểm tra xem database với database_id có đang sao lưu dữ liệu hay không
   * Kiểm tra xem người dùng hiện tại có đang thực hiện sao lưu không
   * Kiểm tra xem người dùng hiện tại có đang thực hiện khôi phục dữ liệu không
   * nvxuan 20.11.2023
   */
  async checkBusyBackupRestore(dbId, userId) {
    return await accountApi.checkBusyBackupRestore(dbId, userId);
  },

  /**
   * Cập nhật số lần hủy bỏ/ Đã hoàn thành khảo sát
   * @param {*} payload {serveyCustomID, userId, state}
   * @returns
   * nvxuan 02.02.2024
   */
  async recordNpsServey(payload) {
    return await accountApi.recordNpsServey(payload);
  },
  /**
   * Cập nhật số lần hủy bỏ/ Đã hoàn thành khảo sát
   * @param {*} payload {serveyCustomID, userId, state}
   * @returns
   * nvxuan 02.02.2024
   */
  async recordNpsServeyProactive(payload) {
    return await accountApi.recordNpsServeyProactive(payload);
  },
};
const getters = {
  PostedDate() {
    return this.context.PostedDate;
  },

  CurUserId() {
    return this.context?.Context?.UserId;
  },

  CurDatabaseId() {
    return this.context?.Context?.DatabaseId;
  },
  CurDatabaseName() {
    return this.context?.Context?.DatabaseName;
  },
  CurAccountingDate() {
    return this.context?.Context?.AccountingDate;
  },

  CurTenantId() {
    return this.context?.Context?.TenantId;
  },
  CurTenantName() {
    return this.context?.Context?.TenantName;
  },

  CurSessionId() {
    return this.context?.Context?.SessionId;
  },
  IsAdmin() {
    const adRoleId = '5bc4acb2-e76c-11ee-ab64-005056b3df23',
      adRoleIdOld = '00000000-0000-0000-0000-000000000001',
      curRoleIds = this.context?.Permission?.RoleIDs ? this.context?.Permission?.RoleIDs.split(',') : [],
      isAdminRole = Array.isArray(curRoleIds) && (curRoleIds.includes(adRoleId) || curRoleIds.includes(adRoleIdOld));

    return this.context?.Permission == null || isAdminRole;
  },
  /**
   * lấy thêm thông tin phiên bản ứng với dữ liệu
   * vqphong - 01/08/2024 (pbi 96975)
   */
  CurVersionApp() {
    return this.context?.Context?.Version;
  },
  /**
   * key bật/tắt chức năng kiểm tra định mức
   * vqphong - 09/10/2024
   */
  IsEnableAvaCheckNorm() {
    return this.context?.Context?.IsEnableAvaCheckNorm;
  },
};

export const useContextStore = defineStore(ModuleContext, {
  state: () => state,
  actions,
  getters: getters,
  persist: {
    storage: localStorage,
    beforeRestore: (ctx, action) => {},
    afterRestore: (ctx, action) => {},
    debug: true,
  },
});
